import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=65043c34&scoped=true"
import script from "./notFound.vue?vue&type=script&lang=ts"
export * from "./notFound.vue?vue&type=script&lang=ts"
import style0 from "./notFound.vue?vue&type=style&index=0&id=65043c34&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65043c34",
  null
  
)

export default component.exports